import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const PinUnlockModal = ({ open, onClose, onSubmit, isVerifying, errorMsg, rateLimitWarning }) => {
  const [pin, setPin] = useState("");

  const handleClose = () => {
    setPin("");
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pin.length >= 4 && pin.length <= 8 && !isVerifying) {
      onSubmit(pin);
      setPin("");
    }
  };

  return (
    <Dialog open={open} onClose={isVerifying ? null : handleClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
          <LockIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
          <Typography variant="h6" component="span" fontWeight="bold" display="block">
            Profile Locked
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3 }}>
            Enter the 4-8 digit PIN to view the locked sections of this profile.
          </Typography>

          <TextField
            autoFocus
            fullWidth
            label="Enter PIN"
            variant="outlined"
            type="password"
            autoComplete="off"
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              maxLength: 8,
              "aria-label": "Profile unlock PIN",
            }}
            value={pin}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9]/g, "");
              setPin(val);
            }}
            disabled={isVerifying || !!rateLimitWarning}
            error={!!errorMsg}
            helperText={errorMsg}
          />

          {rateLimitWarning && (
            <Box mt={2} p={1.5} bgcolor="#fff3e0" borderRadius={1} border="1px solid #ffcc80">
              <Typography variant="body2" color="#e65100" textAlign="center" fontWeight="bold">
                {rateLimitWarning}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3, pt: 1 }}>
          <Button 
            onClick={handleClose} 
            color="inherit" 
            disabled={isVerifying}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={pin.length < 4 || isVerifying || !!rateLimitWarning}
            sx={{ minWidth: 100 }}
          >
            {isVerifying ? <CircularProgress size={24} color="inherit" /> : "Unlock"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PinUnlockModal;